import { Button } from 'antd';
import { SearchRemoveIcon } from '@hugeicons/core-free-icons';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/index.js';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={SearchRemoveIcon}
      title="Page not found"
      description="The page you were looking for does not exist, or you may not have access to it."
      action={{ label: 'Go to Home', onClick: () => navigate('/') }}
      secondaryAction={<Button onClick={() => navigate(-1)}>Go back</Button>}
    />
  );
}
